import { Inject, Injectable } from '@angular/core';
import { SupportedSyncTypes } from '@mode/github/contract';
import { ToastService } from '@mode/shared/util-toast';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { GithubSyncClientService } from '../../client/github-sync-client.service';
import { GITHUB_SYNC_DIALOG_TOKEN, GithubSyncDialog } from '../github.types';
import * as GithubActions from './github-sync-dialog.actions';

@Injectable()
export class GithubSyncDialogEffects {
  private syncToClientMap: {
    [key in SupportedSyncTypes]: (token: string, org: string, commitMessage: string) => Observable<any>;
  } = {
    [SupportedSyncTypes.Dataset]: this.githubSyncClientService.syncDatasetToGithub,
    [SupportedSyncTypes.Definition]: this.githubSyncClientService.syncDefinitionToGithub,
    [SupportedSyncTypes.Report]: this.githubSyncClientService.syncReportToGithub,
  };

  pushToGithub$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GithubActions.githubSyncDialogChangesPushed),
      switchMap((action) =>
        this.syncToClientMap[action.dialogData.syncType].bind(this.githubSyncClientService)(
          action.dialogData.token,
          action.dialogData.workspace,
          action.commitMessage
        )
      ),
      map(() => GithubActions.githubSyncDialogPushSucceeded()),
      catchError((err) => of(GithubActions.githubSyncDialogPushFailed({ error: err })))
    )
  );

  pushToGithubSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GithubActions.githubSyncDialogPushSucceeded),
        tap(() => {
          this.githubSyncDialog.close();
          this.toastService.success('Push started');
        })
      ),
    {
      dispatch: false,
    }
  );

  pushToGithubFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GithubActions.githubSyncDialogPushFailed),
        tap(() => {
          this.githubSyncDialog.close();
          this.toastService.error('Something went wrong');
        })
      ),
    {
      dispatch: false,
    }
  );

  constructor(
    private actions$: Actions,
    private githubSyncClientService: GithubSyncClientService,
    private toastService: ToastService,
    @Inject(GITHUB_SYNC_DIALOG_TOKEN) private githubSyncDialog: GithubSyncDialog
  ) {}
}
